<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div>
        <el-form ref="elFormDom" inline :model="table.params" size="small">
          <el-form-item label="姓名" prop="name">
            <el-input
              clearable
              v-model="table.params.name"
              placeholder="请输入"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="account">
            <el-input
              clearable
              v-model="table.params.account"
              placeholder="请输入"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-row style="margin-top: 10px">
        <el-button size="small" type="primary" @click="toEdit"
          >创建账号</el-button
        >
      </el-row>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        indexLabel="序号"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:role_type="{ row }">
          <span>{{toStr({1:'管理员',2:'代理',3:'企业'},row.role_type)}}</span>
        </template>
        <template v-slot:action="{ row }">
          <el-button type="text" @click="editPassword(row)">修改密码</el-button>
          <el-button type="text" @click="deleteRow(row)">删除</el-button>
        </template>
      </VTable>
    </div>
    <edit ref="editRef" @refresh="getTable"></edit>
    <editPassword ref="editPasswordRef" @refresh="getTable"></editPassword>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import edit from "./components/edit.vue";
import editPassword from "./components/editPassword.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "ReportList",
  mixins: [mixinTable],
  components: {
    VTable,
    edit,
    editPassword,
  },
  data() {
    return {
      field: [
        { name: "name", label: "姓名", hidden: false },
        { name: "account", label: "账号", hidden: false },
        { name: "role_type", label: "权限", hidden: false },
        {
          name: "create_time",
          label: "创建时间",
          hidden: false,
        },
        { name: "action", label: "操作", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          name: "",
          account: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http
        .get("/admin/admin/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.share_open_status = res.data.share_open_status;
            this.share_days = res.data.share_days;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 重置查询条件
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    showDetails(row) {},
    toEdit() {
      let dom = this.$refs.editRef;
      dom.toggle(true);
    },
    editPassword(row) {
      let dom = this.$refs.editPasswordRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
    deleteRow(row) {
      this.$confirm("是否删除该账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() =>{
        this.$http.post('/admin/admin/delete',{id:row.id}).then(res=>{
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.getTable()
          }
        })
      })

    }
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.t {
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
}
.justify-between {
  justify-content: space-between;
}
.m {
  margin: 0 5px 0 35px;
}
</style>